import Image from "next/image";

interface FigureProps {
	src: string;
	/** Alt text for screen readers. Describe the image; keep it concise. */
	alt: string;
	/** Visible caption shown below the image for all readers. */
	caption?: React.ReactNode;
	width?: number;
	height?: number;
}

/**
 * An image with an optional visible caption, for use in blog MDX.
 *
 * The `alt` text serves screen readers; the `caption` is shown to everyone.
 * Give them different content: `alt` should describe what the image depicts,
 * while `caption` can add context, a label, or a source note.
 */
export function Figure({
	src,
	alt,
	caption,
	width = 1200,
	height = 630,
}: FigureProps) {
	return (
		<figure className="my-8">
			<Image
				src={src}
				alt={alt}
				width={width}
				height={height}
				sizes="100vw"
				style={{ width: "100%", height: "auto" }}
				className="rounded-lg shadow"
				loading="lazy"
			/>
			{caption ? (
				<figcaption className="mt-3 text-center text-sm text-foreground/50 italic">
					{caption}
				</figcaption>
			) : null}
		</figure>
	);
}
